import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const categoryAttributes = async (id?: number) =>
  axios.get(Routes.CATEGORY_ATTRIBUTES + "?q=" + id);

export const useCategoryAttributes = (id?: number) =>
  useQuery({
    queryKey: [Keys.CATEGORY_ATTRIBUTES_QRY, id],
    queryFn: () => categoryAttributes(id),
    enabled: id ? true : false,
  });
